JSON.stringify({entities:[{id:"string",fileType:"string",fileUri:"string"}]});var i={ongoing:"ongoing",success:"success",failed:"failed"};export{i as UPLOAD_STATUS};
//# sourceMappingURL=useFileUpload.constants.js.map
